import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'
import { Overlay } from '../styles/ConfirmPinModalStyle'
import { Divider, Footer } from '../styles/ResetPasswordModalStyle'
import { Body, Dialog, Header } from '../styles/ReviewKYCModalStyle'

interface Props {
   open: boolean
   username: string
   bvnNumber?: string | undefined | null
   ninNumber?: string | undefined | null
   onClose: () => void
   onApprove?: () => void
   onReject?: () => void
}

export default function ReviewKYCModal({ open, username, bvnNumber, ninNumber, onClose, onApprove, onReject }: Props) {
   const [showBvn, setShowBvn] = useState(false)
   const [showNin, setShowNin] = useState(false)

   useEffect(() => {
      function esc(e: KeyboardEvent) { if (e.key === 'Escape') onClose() }
      if (open) window.addEventListener('keydown', esc)
      return () => window.removeEventListener('keydown', esc)
   }, [open, onClose])

   if (!open) return null

   return (
      <Overlay onClick={onClose}>
         <Dialog onClick={e => e.stopPropagation()} role='dialog' aria-modal='true' aria-labelledby='kyc-title'>
            <Header>
               <h2 id='kyc-title'>Review KYC</h2>
               <button aria-label='Close' onClick={onClose}><Icon icon='material-symbols:close' width={20} /></button>
            </Header>
            <Body>
               <div className='mb-3 flex justify-between pr-5'>
                  <div className='text-[12px] tracking-tight text-[#9C9C9F] mb-1'>Username</div>
                  <span className='inline-block bg-[#F5F5F6] text-[#3F3F45] px-3 py-1 rounded-full text-sm font-medium font-geist-mono'>@{username}</span>
               </div>
               <div className='mb-4 flex items-center justify-between gap-2 pr-5'>
                  <div className='w-[90px] text-[12px] tracking-tight text-[#9C9C9F]'>BVN</div>
                  <div className='flex items-center gap-3'>
                     <span className='tracking-widest'>
                        {bvnNumber ? (showBvn ? bvnNumber : '••••••••••') : 'N/A'}
                     </span>
                     {bvnNumber && (
                        <button onClick={() => setShowBvn(v => !v)} aria-label='Toggle BVN visibility' className='p-1 rounded hover:bg-[#F5F5F6]'>
                           <Icon icon={showBvn ? 'solar:eye-linear' : 'solar:eye-closed-linear'} width={18} />
                        </button>
                     )}
                  </div>
               </div>
               <div className='mb-4 flex items-center justify-between gap-2 pr-5'>
                  <div className='w-[90px] text-[12px] tracking-tight text-[#9C9C9F]'>NIN</div>
                  <div className='flex items-center gap-3'>
                     <span className='tracking-widest'>
                        {ninNumber ? (showNin ? ninNumber : '••••••••••') : 'N/A'}
                     </span>
                     {ninNumber && (
                        <button onClick={() => setShowNin(v => !v)} aria-label='Toggle NIN visibility' className='p-1 rounded hover:bg-[#F5F5F6]'>
                           <Icon icon={showNin ? 'solar:eye-linear' : 'solar:eye-closed-linear'} width={18} />
                        </button>
                     )}
                  </div>
               </div>
               <Divider />
               <div className='mt-3'>
                  <div className='text-[#101018] font-semibold mb-2'>Uploaded documents</div>
                  <div className='flex items-center justify-between pr-5 py-3 text-[#9C9C9F] border-b border-[#F1F1F3]'>
                     <span>Passport photo page</span>
                     <button className='text-[#101018] underline underline-offset-2 hover:opacity-80'>View</button>
                  </div>
                  <div className='flex items-center justify-between py-3 pr-5 text-[#9C9C9F]'>
                     <span>Selfie</span>
                     <button className='text-[#101018] underline underline-offset-2 hover:opacity-80'>View</button>
                  </div>
               </div>
            </Body>
            <Divider />
            <Footer>
               <button className='cancel' onClick={() => { onReject?.(); onClose() }}>Reject</button>
               <button className='primary' onClick={() => { onApprove?.(); onClose() }}>Approve</button>
            </Footer>
         </Dialog>
      </Overlay>
   )
}
